<template>
  <div class="account-page scrollable">
    <div class="page-header">
      <h1>Posts List</h1>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="mdi mdi-home-outline"></i>
        </el-breadcrumb-item>
        <el-breadcrumb-item>Posts Table</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <el-form inline>
      <div class="filter-user">
        <el-input
            @change="findPost"
            placeholder="Search posts"
            v-model="searchPost"
            prefix-icon="el-icon-search"
        ></el-input>
      </div>
    </el-form>

    <el-date-picker
        @change="handleDatePickerChange"
        v-model="dateRange"
        :picker-options="datePickerOptions"
        type="daterange"
        class="date-range-picker"
        format="MM-dd-yyyy" :clearable="true"
        value-format="yyyy-MM-dd"
        size="mini"  align="right"
        start-placeholder="Start Date"
        end-placeholder="End Date">
    </el-date-picker>

    <div class="top-bar">
      <div class="count-posts">
        Show
        <el-select
            v-model="countPosts"
            @change="changeCount"
            placeholder=" "
        >
          <el-option
              v-for="item in countPostsOptions"
              :key="item.value"
              :label="item.value"
              :value="item.value"
          >
          </el-option>
        </el-select>
        entries
      </div>
      <button type="button"
              class="el-button el-button--primary"
              @click="addPost">
        <span>Add new</span>
      </button>
    </div>

    <el-table
        ref="indexingTable"
        :data="posts"
        style="width: 100%;"
        @sort-change="sort"
        @filter-change="filterChange"
    >
      <el-table-column label="#" type="index"></el-table-column>

      <el-table-column prop="title" label="Title">
        <template slot="header" slot-scope="scope">
          <header-sort-title
              @sort="sort"
              title="Title"
              :status-sort="sortBy"
              sort-key="title"
          />
        </template>
        <template slot-scope="scope">
          {{ scope.row.title }}
        </template>
      </el-table-column>

      <el-table-column prop="author" label="Author">
        <template slot-scope="scope">
          {{ scope.row.author.name }}
        </template>
      </el-table-column>

      <el-table-column
          prop="category"
          label="Category"
          column-key="category_id"
          show-overflow-tooltip
          :filters="getCategoryFilters()"
          filter-placement="bottom-end"
      >
        <template v-slot="scope">
          <span>{{ scope.row.categories.map(c => c.name).join(', ') }}</span>
        </template>
      </el-table-column>

      <el-table-column
          prop="tags"
          label="Tags"
          column-key="tag_id"
          show-overflow-tooltip
          :filters="getTagsFilters()"
          filter-placement="bottom-end"
      >
        <template v-slot="scope">
          <span>{{ scope.row.tags.map(t => t.name).join(', ') }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="created_at" label="Date">
        <template slot="header" slot-scope="scope">
          <header-sort-title
              @sort="sort"
              title="Date"
              :status-sort="sortBy"
              sort-key="created_at"
          />
        </template>
        <template slot-scope="scope">
          {{ new Date(scope.row.created_at).toLocaleString() }}
        </template>
      </el-table-column>

      <el-table-column
          prop="status"
          label="Status"
          column-key="status"
          :filters="[
            {text: 'Published', value: 'publish' },
            {text: 'Inherit', value: 'inherit' },
            {text: 'Draft', value: 'draft'},
          ]"
      >
        <template slot-scope="scope">
          {{ scope.row.status }}
        </template>
      </el-table-column>

      <el-table-column align="right">
        <template slot="header" slot-scope="scope">
          <span>Actions</span>
        </template>
        <template slot-scope="scope">
          <el-button size="mini" @click="editPost(scope.row)"
          >Edit
          </el-button>
          <el-button
              size="mini"
              type="danger"
              @click="deletePost(scope.row)"
          >Delete
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagin-wrp">
      <el-pagination
          :current-page="chosenPageFromVuex"
          :background="true"
          layout="prev, pager, next"
          :page-size="1"
          @current-change="chosePage"
          :total="meta.last_page"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import HeaderSortTitle from "../../../../components/UsersList/HeaderSortTitle.vue";
import analyticFormatData from '@/mixins/analyticFormatData';

export default {
  name: 'IndexingPages',
  components: {HeaderSortTitle},
  mixins: [analyticFormatData],
  data () {
    return {
      datePickerOptions: {
        firstDayOfWeek: 1,
        disabledDate: this.handleMinMaxDatePicker
      },
      dateRange: [],
      filterBlock:{},
      categoryFilters: [],
      searchPost: '',
      sortBy: {
        title: 0,
        created_at: 0,
        category:0,
      },
      countPostsOptions: [
        {value: 10},
        {value: 25},
        {value: 50},
        {value: 100},
      ],
      inputURL: '',
      search: ''
    }
  },
  computed: {
    ...mapGetters({
        posts: 'posts/getPosts',
        meta: 'posts/getPostsMeta',
        categories: 'posts/getCategories',
        tags: 'posts/getTags',
        selectedFilter: 'posts/getSelectedFilter',
        chosenPageFromVuex: 'postsFilter/getChosenPage',
        countPostsFromVuex: 'postsFilter/getCountPosts',
    }),
    chosenPage: {
      get() {
        return this.chosenPageFromVuex;
      },
      set(value) {
        this.$store.dispatch('postsFilter/updateChosenPage', value);
      },
    },
    countPosts: {
      get() {
        return this.countPostsFromVuex;
      },
      set(value) {
        this.$store.dispatch('postsFilter/updateCountPosts', value);
        this.updatePostsList();
      },
    },
  },
  created () {
    let params = {};
    if (this.countPosts) {
      params = {
        per_page: this.countPosts,
        sort_column: 'created_at',
        sort_direction: 'DESC'
      }

    }
    this.$store.dispatch('posts/getPosts', params)
    this.$store.dispatch('posts/getCategories')
    this.$store.dispatch('posts/getTags',{
      sort_column: 'name',
      sort_direction: 'ASC'
    })
  },
  watch: {
    searchPost(){
      this.updatePostsList()
    }
  },
  methods: {
    ...mapActions('posts', ['getPosts']),
    chosePage (e) {
      this.chosenPage = e
      this.updatePostsList()
    },
    updatePostsList() {
      let params = {};

      if (this.sortBy) {
        for (let itm in this.sortBy) {
          if (this.sortBy[itm] === 1) {
            params['sort_column'] = itm;
            params['sort_direction'] = 'ASC';
          } else if (this.sortBy[itm] === -1) {
            params['sort_column'] = itm;
            params['sort_direction'] = 'DESC';
          }
        }
      }

      if (Object.keys(this.filterBlock).length) {
        Object.entries(this.filterBlock).forEach(([key, value]) => {
          if (value.length === 0) {
            return;
          }
          params[key] = value[0];
        });
      }

      if (this.dateRange[0] !== undefined && this.dateRange[1] !== undefined) {
        params['min_created_at'] = this.dateRange[0];
        params['max_created_at'] = this.dateRange[1];
      }

      if (this.searchPost.length) {
        params['search'] = this.searchPost;
      }

      params['page'] = this.chosenPage;

      if (this.countPosts) {
        params['per_page'] = this.countPosts;
      }

      this.$store.dispatch('posts/getPosts', params);
    },
    findPost(e) {
      this.searchPost = e
      this.updatePostsList()
    },
    changeCount (e) {
      this.$store.dispatch('postsFilter/getCountPosts', e);
      this.updatePostsList()
    },
    sort(by) {
      let key  = (typeof by ==="object") ? by.prop : by

      if (this.sortBy[key] === 0) {
        this.sortBy[key] = 1
      } else if (this.sortBy[key] === 1) {
        this.sortBy[key] = -1
      } else if (this.sortBy[key] === -1) {
        this.sortBy[key] = 0
      }
      if(typeof by ==="object" && by.order==null){
        this.sortBy[key] = 0
      }
      this.updatePostsList()
    },
    filterChange(filter) {
      Object.assign(this.filterBlock, filter)
      this.updatePostsList();
    },
    deletePost(params) {
        this.$store.dispatch('posts/deletePost', params.id)
    },
    editPost(row) {
      this.$router.push({name: 'post-edit', params: {id: row.id}})
    },
    getCategoryFilters() {
      return this.categories.map(category => ({
        text: category.name,
        value: category.id
      }));
    },
    getTagsFilters() {
      return this.tags.map(tag => ({
        text: tag.name.length > 20 ? tag.name.slice(0, 20) + '...' : tag.name,
        value: tag.id
      }));
    },
    handleDatePickerChange(range) {
      this.dateRange = this.dateRange ? range : []
      this.updatePostsList()
    },
    addPost() {
      this.$router.push({name: 'post-create'})
    }
  }
}
</script>